import React, { useEffect, useRef } from 'react'
import Seo from './Seo'
import Contact from './conatct'
import Footer from './footer'
import { Container, Row, Col,  } from 'reactstrap'
import ObserverIMG from '../assets/images/Observer-Illustration.jpg'
import { ScrollEffect } from 'react-easy-scroll-effect'
import DownloadBrochure from './downloadBrochure'
import PHImg from '../assets/images/Banner/Case Study Banner.png'
import Velocis from '../assets/images/HCL-Case-Study.png'
import Agilus from '../assets/images/Thumnails/Agilus-Brochure.png'
import Bullseye from '../assets/images/Thumnails/BullsEye-Brochure.png'
import { Link } from 'react-router-dom'

const CaseStudy = () => {
  const downlaodBroRef = useRef();
       const downloadBroClick = (val) =>{
          downlaodBroRef.current.openModal()
          downlaodBroRef.current.cnameFun(val)
      }

      useEffect(() => {
        document.title = 'Success Stories | Agilus Technologies'
      }, [])
return (
 <div>
      <Seo
        title="Success Stories"
        description="Discover how businesses succeed with Agilus IT infrastructure management solutions through our case studies."
        path="/successstories"
      />
   {/* hero section */}

   <section className='custom-margin-for-header'>
         <img src={PHImg} className='img-fluid' />
     </section>

    {/* discreption */}
     <section className='ce-hero-section py-5 text-center'>
         <Container >
             <Row>
             <Col sm={12} className=''>
                 <h1 className='fw-normal font-50 archivo-medium'>Success Stories</h1>
                 <p>Explore our case studies, that have enabled digital transformations for you, across different services and domains.</p>
             </Col>
             </Row>
         </Container>

     </section>

      {/* download case study */}
      <section className='blog px-3 pb-5 my-4 archivo-normal'>
         <div className='p-5 custom-rounded bg-gray-light'>
         <ScrollEffect id='8'>
             <Container>
             <Row>
                 {/* <Col sm={12} className='text-center mb-4'>
                     <h1 className='fw-semibold'>Latest Article</h1>
                 </Col> */}
                 <Col sm={4}>
                 <div className='blog-item blog-item-height custom-rounded cursor-pointer' onClick={()=> downloadBroClick({title:'Fortifying Network Security and Compliance through Automated audits and Remediation for a Global IT Services Provider', cname:'Fortifying Network Security and Compliance through Automated audits and Remediation for a Global IT Services Provider', fileType : 'Success Story NCP'})}>
                         <img src={Velocis} className='img-fluid custom-rounded'/>
                         <span className='blog-tag blog-tag-bg-blue'>Download Success Story</span>
                         <h5 className='fw-normal cursor-pointer'><DownloadBrochure ref={downlaodBroRef} /> </h5>
                         <div className='text-custom-ellipsis' title='Fortifying Network Security and Compliance through Automated audits and Remediation for a Global IT Services Provider'> Fortifying Network Security and Compliance through Automated audits and Remediation for a Global IT Services Provider </div>
                     </div>
                 </Col>
                
             </Row>
             </Container>
             </ScrollEffect>
         </div>
     </section>
 
 {/* contact */}
 <Contact />

 {/* footer */}
 <Footer />
 </div>
)
}

export default CaseStudy
